module.exports = __webpack_public_path__ + "static/img_4371-60b926627889abed9f463853d72e2de5.webp";